export default __webpack_public_path__ + "static/media/open-shop.5c7773b7.svg";